import Vue from "vue"

export default {
  namespaced: true,

  state: {
    isFullscreen: false
  },

  mutations: {
    setFullscreen(state, isFullscreen = true) {
      Vue.set(state, "isFullscreen", isFullscreen)
    }
  }
}
